import { delay, put, call, takeEvery } from 'redux-saga/effects';

import { createProfileLoadingAction } from '../actions/auth';
import { AuthInfoActions } from '../constants/auth';
import { createShowErrorAction } from '../actions/notifications';
import * as authActions from '../actions/auth';

import api from '../server/auth';
import graphSettings from '../config/graphSettings';
import { getAccessTokenEffect } from './helpers';

const setIsProfileLoading = createProfileLoadingAction();
const setProfileAction = authActions.createSetProfileAction();
const showErrorAction = createShowErrorAction();

export function* getProfileEffect(action) {
  try {
    yield put(setIsProfileLoading(true));
    yield delay(500);

    const accessToken = yield call(getAccessTokenEffect, graphSettings.scopes);
    const profile = yield call(api.getProfile, accessToken);
    yield put(setProfileAction(profile.data));
    yield put(setIsProfileLoading(false));     
  } catch (e) {
    console.log(e);
    yield put(showErrorAction('Cannot load profile' + e.message));		
  } finally {
    yield put(setIsProfileLoading(false));
  }
}

export default [
    takeEvery(AuthInfoActions.GetProfile, getProfileEffect),
];